// combatpro/panels/monsters/MonsterWorkspace.js
//
// Combat PRO - MonsterWorkspace (decomposition of MonsterPanel.js).
//
// Composes the view-monsters section from the extracted child components,
// reproducing the original DOM exactly. This component owns the structural
// wrappers that have no dedicated component of their own: the root
// vi-view#view-monsters container, the search-section wrapper, and the empty
// monsterPanels mount. The order and nesting match MonsterPanel.js verbatim:
//   view-monsters
//     MonsterSlots          (vi-active-slots-bar)
//     MonsterTabs           (monster-tabs)
//     search-section
//       MonsterSearch       (search input + filter toggle)
//       MonsterFilters      (advancedFilters)
//       MonsterResults      (searchResults)
//     monsterPanels         (active monster: MonsterDetailPanel)
//
// Stage 40 (Monster Panel Integration): the previously empty monsterPanels mount
// now renders MonsterDetailPanel for the active monster. Imports React and the
// child components. No state or handlers live in this composer.

import React from 'react';
import MonsterSlots from './MonsterSlots';
import MonsterTabs from './MonsterTabs';
import MonsterSearch from './MonsterSearch';
import MonsterFilters from './MonsterFilters';
import MonsterResults from './MonsterResults';
import MonsterDetailPanel from './MonsterDetailPanel';

function MonsterWorkspace() {
  return (
    <div className="vi-view" id="view-monsters">
      <MonsterSlots />
      <MonsterTabs />
      <div className="search-section">
        <MonsterSearch />
        <MonsterFilters />
        <MonsterResults />
      </div>
      <div id="monsterPanels"><MonsterDetailPanel /></div>
    </div>
  );
}

export default MonsterWorkspace;
